exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".images[data-v-0704ed12]{position:relative;height:200px;margin-left:-1.25rem;margin-top:-1.25rem;margin-right:-1.25rem}.images .carousel[data-v-0704ed12] .carousel-inner{position:absolute;width:100%;height:100%}@media (max-width:991.98px){.images .carousel[data-v-0704ed12] .carousel-caption,.images .carousel[data-v-0704ed12] .carousel-indicators{display:none}}.card-body[data-v-0704ed12] p:last-child{margin-bottom:0}li .card[data-v-0704ed12]{margin-bottom:.75rem}li:last-child .card[data-v-0704ed12]{margin-bottom:unset}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0704ed12","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Components/Content/Teaser.vue
// module id = 289
// module chunks = 7 8 9